import { Skeleton as MuiSkeleton } from '@mui/material';
import { Skeleton as AntSkeleton, Col, Row } from 'antd';
import React from 'react';
// import data from '../mock/graphData.json';
import BarAndLineChart from '../reusable-component/dataQualityInsightCharts/BarAndLineChart';
import DoughnutChart from '../reusable-component/dataQualityInsightCharts/DoughnutChart';
import DqLLMTable from '../reusable-component/dataQualityInsightCharts/DqLLMTable';
import PieChart from '../reusable-component/dataQualityInsightCharts/PieChart';
import ScatterPlotChart from '../reusable-component/dataQualityInsightCharts/ScatterPlotChart';
import SeriesBarChart from '../reusable-component/dataQualityInsightCharts/SeriesBarChart';
import './DataQualityInsights.css';

function DataQualityInsights2({ data, loading }) {
  return (
    <div>
      {loading ? (
        <div style={{ margin: '24px' }}>
          <MuiSkeleton variant="rounded" width={250} height={50} style={{ margin: '0 0 16px 0' }} />
          <div style={{ display: 'flex', marginBottom: '16px' }}>
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
          </div>
          <AntSkeleton.Image active style={{ width: 350, height: 350, margin: '0 0 16px 300px' }} />
          <MuiSkeleton variant="rounded" width={250} height={50} style={{ margin: '0 0 16px 0' }} />
          <div style={{ display: 'flex', marginBottom: '16px' }}>
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
            <MuiSkeleton variant="rounded" width={210} height={75} style={{ marginRight: '8px' }} />
          </div>
          <AntSkeleton.Image active style={{ width: 350, height: 350, margin: '0 0 16px 300px' }} />
        </div>
      ) : (
        <Row>
          {/* <Col xl={20} lg={20} md={18} sm={24} xs={24}> */}
          <Col span={24}>
            {data?.map((item) => (
              <>
                <div className="dsqi-title">{item.title}</div>
                {item?.cards && (
                  <div className="dsqi-row">
                    {Object.entries(item.cards)
                      ?.sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
                      ?.map(([key, value]) => (
                        <div className="single-card" key={key}>
                          <div className="single-card-heading">{key}</div>
                          <div className="single-card-value">{value}</div>
                        </div>
                      ))}
                  </div>
                )}

                <Row gutter={16}>
                  {item?.graphs &&
                    item?.graphs?.map((graph) => (
                      <>
                        <Col span={12}>
                          {graph?.type === 'pie' && <PieChart item={graph} />}
                          {graph?.type === 'doughnut' && <DoughnutChart item={graph} />}
                          {(graph?.type === 'bar' || graph?.type === 'line') && <BarAndLineChart item={graph} />}
                          {graph?.type === 'scatter' && <ScatterPlotChart item={graph} />}
                          {graph?.type === 'series' && <SeriesBarChart item={graph} />}
                          {/* {(graph?.type === 'table') && <DqLLMTable item={graph} />} */}
                        </Col>
                        {graph?.type === 'table' && (
                          <Col span={24}>
                            <DqLLMTable item={graph} />
                          </Col>
                        )}
                      </>
                    ))}
                </Row>
                <br />
              </>
            ))}
          </Col>

          {/* <Col xl={4} lg={4} md={6} sm={24} xs={24}>
            <div className="dsqi-pending-issues">Total Pending issues</div>
            <Row gutter={16}>
              <Col span={12}>
                <div className="dsqi-single-card">
                  <div className="single-card-heading">Total</div>
                  <div className="single-card-value" style={{ color: '#2E86C1' }}>
                    95
                  </div>
                </div>
              </Col>
            </Row>
          </Col> */}
        </Row>
      )}
    </div>
  );
}

export default DataQualityInsights2;
